export default __webpack_public_path__ + "static/media/logo-bpi.ecb6263a.svg";